import { render, staticRenderFns } from "./ReadingCity.vue?vue&type=template&id=50188322&scoped=true&"
import script from "./ReadingCity.vue?vue&type=script&lang=js&"
export * from "./ReadingCity.vue?vue&type=script&lang=js&"
import style0 from "./ReadingCity.vue?vue&type=style&index=0&id=50188322&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50188322",
  null
  
)

export default component.exports